import React, {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import logoSidebar from "../../img/png/logo_sidebar.png";
import {logado} from "../../util/usuario-util";
import {ICONE} from '../../config/constantes/constantes-mantine';
import {Anchor, Container, Space, Title, useProps} from "@mantine/core";

interface PaginaLogadaProps {
  titulo?: string;
  subTitulo?: string;
  isCarregando?: boolean;
  botaoVoltar?: boolean;
  voltarPara?: string | number;
  children: React.ReactNode;
}

const defaultProps: Partial<PaginaLogadaProps> = {
  voltarPara: -1,
  botaoVoltar: false,
};

export default function PaginaLogada(props: PaginaLogadaProps) {

  const {voltarPara, botaoVoltar} = useProps('PaginaLogada', defaultProps, props);
  const navegacao = useNavigate();
  const location = useLocation()

  if (!logado()) {
    window.location.assign("/?url="+location.pathname);
  }

  useEffect(() => {
    // window.clarity("set", "usuario", usuario.email)
  }, [])

  function loader() {
    return props.isCarregando ?
      <div className="preloader flex-column justify-content-center align-items-center">
        <div className={"loader-logo"}><img src={logoSidebar} alt={"logo Asplan"}/></div>
        <div className="spinner"></div>
      </div> : ""
  }

  // @ts-ignore
  const buttonVoltar = botaoVoltar ? <Anchor mt={50} onClick={() => navegacao(voltarPara)}><ICONE.VOLTAR/>Voltar</Anchor> : "";

  return (
    <Container px={0} fluid>
      {loader()}

      <Title order={2}>{props.titulo}</Title>
      {buttonVoltar}
      {props.subTitulo}
      <Space h="xl"/>

      {props.children}

    </Container>
  );

}
